import React from 'react';
import IconButton from './components/IconButton';
import EditActionIcon from './components/EditActionIcon';
import CopyActionIcon from './components/CopyActionIcon';
import TrashActionIcon from './components/TrashActionIcon';
import UnarchiveActionIcon from './components/UnarchiveActionIcon';
import TemplateFormatBadge from './TemplateFormatBadge';

export default function TemplateTiles({ templates = [], onEdit, onCopy, onCloneAs, openFormatMenuId, onOpenFormatMenuChange, onArchive, onUnarchive, showUnarchive = false, currentUser }) {
  const canCopyTemplates = currentUser?.roleActions?.indexOf('WriteTemplates') >= 0 ||
    currentUser?.roleActions?.indexOf('AdminTemplates') >= 0;

  return (
    <div className="tile-grid" data-testid="templates-tiles">
      {templates.map((t) => (
        <div key={t.id} className="tile-card" data-testid={`template-tile-${t.id}`}>
          <div className="tile-body">
            <div className="tile-title-row">
              <div>
                <div className="muted" style={{ fontSize: 12 }}>{Array.isArray(t.markets) ? t.markets.join(', ') : t.market}</div>
                <div className="tile-title">{t.name}</div>
              </div>
              <span className="tag subtle">Updated {t.updated}</span>
            </div>
            <div className="muted" style={{ margin: '6px 0 10px' }}>
              Template asset
            </div>
            <div className="tile-actions">
              {(currentUser?.roleActions?.indexOf('WriteTemplates') >= 0 ||
                currentUser?.roleActions?.indexOf('AdminTemplates') >= 0) && <IconButton title="Edit" ariaLabel={`Edit ${t.name}`} onClick={() => onEdit && onEdit(t)} testId={`template-edit-${t.id}`}>
                <EditActionIcon />
              </IconButton>}
              {(currentUser?.roleActions?.indexOf('WriteTemplates') >= 0 ||
                currentUser?.roleActions?.indexOf('AdminTemplates') >= 0) && <IconButton title="Copy" ariaLabel={`Copy ${t.name}`} onClick={() => onCopy && onCopy(t)} testId={`template-copy-${t.id}`}>
                <CopyActionIcon />
              </IconButton>}
              {currentUser?.roleActions?.indexOf('AdminTemplates') >= 0 && !showUnarchive && <IconButton title="Archive" ariaLabel={`Archive ${t.name}`} onClick={() => onArchive && onArchive(t)} testId={`template-archive-${t.id}`}>
                <TrashActionIcon />
              </IconButton>}
              {currentUser?.roleActions?.indexOf('AdminTemplates') >= 0 && showUnarchive && <IconButton title="Unarchive" ariaLabel={`Unarchive ${t.name}`} onClick={() => onUnarchive && onUnarchive(t)} testId={`template-unarchive-${t.id}`}>
                <UnarchiveActionIcon />
              </IconButton>}
               <TemplateFormatBadge
                 template={t}
                 interactive={canCopyTemplates}
                 isOpen={openFormatMenuId === t.id}
                 alignment="right"
                 onOpenChange={(open) => onOpenFormatMenuChange?.(open ? t.id : null)}
                 onCloneAs={(target) => onCloneAs?.(t, target)}
               />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
